export default __webpack_public_path__ + "static/DSC_0444-423de4b85fc53003e8871374c0137003.jpg";